import React, { createContext, useContext } from 'react';
import { AttendanceUploadAccess } from 'services/AttendanceTrackingService';

const AttendanceTrackingAccessContext =
  createContext<AttendanceUploadAccess | null>(null);

export const AttendanceTrackingAccessProvider = ({
  access,
  children
}: {
  access: AttendanceUploadAccess;
  children: React.ReactNode;
}) => (
  <AttendanceTrackingAccessContext.Provider value={access}>
    {children}
  </AttendanceTrackingAccessContext.Provider>
);

export const useAttendanceTrackingAccess = () => {
  const context = useContext(AttendanceTrackingAccessContext);
  if (!context) {
    throw new Error(
      'useAttendanceTrackingAccess must be used within AttendanceTrackingAccessProvider'
    );
  }
  return context;
};
